const MONTH_NAME_TO_NUMBER = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
};

function parseMonthToken(token) {
  const raw = String(token || '').trim().toLowerCase();
  if (!raw) return null;
  const asNumber = Number(raw);
  if (Number.isFinite(asNumber) && asNumber >= 1 && asNumber <= 12) {
    return asNumber;
  }
  return MONTH_NAME_TO_NUMBER[raw.slice(0, 3)] ?? null;
}

export function parseCohortDate(dateStr) {
  const s = String(dateStr || '').trim();
  if (!s) return null;

  const iso = s.match(/^(\d{4})-(\d{1,2})(?:\D|$)/);
  if (iso) {
    const month = Number(iso[2]);
    if (month >= 1 && month <= 12) {
      return { year: Number(iso[1]), month };
    }
  }

  const yearMonthName = s.match(/^(\d{4})[-/]([A-Za-z]{3,9})/);
  if (yearMonthName) {
    const month = parseMonthToken(yearMonthName[2]);
    if (month) return { year: Number(yearMonthName[1]), month };
  }

  const monthNameYear = s.match(/^([A-Za-z]{3,9})[-/](\d{4})/);
  if (monthNameYear) {
    const month = parseMonthToken(monthNameYear[1]);
    if (month) return { year: Number(monthNameYear[2]), month };
  }

  const parts = s.split(/[/-]/);
  if (parts.length >= 2) {
    const first = parseMonthToken(parts[0]);
    const second = parseMonthToken(parts[1]);
    const a = Number(parts[0]);
    const b = Number(parts[1]);
    if (Number.isFinite(a) && a > 1900) {
      const month = second ?? (Number.isFinite(b) && b >= 1 && b <= 12 ? b : null);
      if (month) return { year: a, month };
    }
    if (Number.isFinite(b) && b > 1900) {
      const month = first ?? (Number.isFinite(a) && a >= 1 && a <= 12 ? a : null);
      if (month) return { year: b, month };
    }
  }
  return null;
}
